import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const responseSchema = yup.object({
  syncAll: yup.boolean().required(),
  syncNew: yup.boolean().required(),
  accessToken: yup.string().nullable(),
  url: yup.string().required(),
  date: yup.string().nullable(),
});

const composeResponse = (res) => {
  const data = res?.data?.data || {};
  return {
    syncAll: Boolean(data.sync_all),
    syncNew: Boolean(data.sync_new),
    accessToken: data.auth_data?.access_token || null,
    url: data.url,
    date: data.auth_data?.created || null,
  };
};

export function useConstantContactAuthDataQuery(options = {}) {
  return useQuery(
    [QUERY_KEYS.constantContact.authData],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.constantContact.getAuthData());
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
